import { render, staticRenderFns } from "./NotificationSwitch.vue?vue&type=template&id=2183271d&"
import script from "./NotificationSwitch.vue?vue&type=script&lang=js&"
export * from "./NotificationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports